import { createContext, useContext } from "react";

// True while a report table is in color mode; read by rows (including nested group rows)
// to decide whether status cells render as colored badges.
export const ReportColorModeContext = createContext(false);

export const useReportColorMode = () => useContext(ReportColorModeContext);
